/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ValidityEnum } from './ValidityEnum';
import {
    ValidityEnumFromJSON,
    ValidityEnumFromJSONTyped,
    ValidityEnumToJSON,
    ValidityEnumToJSONTyped,
} from './ValidityEnum';
import type { Status111Enum } from './Status111Enum';
import {
    Status111EnumFromJSON,
    Status111EnumFromJSONTyped,
    Status111EnumToJSON,
    Status111EnumToJSONTyped,
} from './Status111Enum';
import type { StealerLeakSeverityEnum } from './StealerLeakSeverityEnum';
import {
    StealerLeakSeverityEnumFromJSON,
    StealerLeakSeverityEnumFromJSONTyped,
    StealerLeakSeverityEnumToJSON,
    StealerLeakSeverityEnumToJSONTyped,
} from './StealerLeakSeverityEnum';
import type { OwnerEnum } from './OwnerEnum';
import {
    OwnerEnumFromJSON,
    OwnerEnumFromJSONTyped,
    OwnerEnumToJSON,
    OwnerEnumToJSONTyped,
} from './OwnerEnum';
import type { TwoFaStatusEnum } from './TwoFaStatusEnum';
import {
    TwoFaStatusEnumFromJSON,
    TwoFaStatusEnumFromJSONTyped,
    TwoFaStatusEnumToJSON,
    TwoFaStatusEnumToJSONTyped,
} from './TwoFaStatusEnum';

/**
 * 
 * @export
 * @interface PatchedStealerLeak
 */
export interface PatchedStealerLeak {
    /**
     * 
     * @type {number}
     * @memberof PatchedStealerLeak
     */
    readonly id?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchedStealerLeak
     */
    identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedStealerLeak
     */
    password?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedStealerLeak
     */
    url?: string | null;
    /**
     * 
     * @type {OwnerEnum}
     * @memberof PatchedStealerLeak
     */
    owner?: OwnerEnum;
    /**
     * 
     * @type {Date}
     * @memberof PatchedStealerLeak
     */
    readonly createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof PatchedStealerLeak
     */
    readonly updatedAt?: Date;
    /**
     * 
     * @type {number}
     * @memberof PatchedStealerLeak
     */
    device?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedStealerLeak
     */
    readonly deviceInfo?: string;
    /**
     * 
     * @type {number}
     * @memberof PatchedStealerLeak
     */
    domain?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedStealerLeak
     */
    readonly domainName?: string;
    /**
     * 
     * @type {number}
     * @memberof PatchedStealerLeak
     */
    service?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedStealerLeak
     */
    readonly serviceName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedStealerLeak
     */
    isMobile?: boolean;
    /**
     * 
     * @type {ValidityEnum}
     * @memberof PatchedStealerLeak
     */
    validity?: ValidityEnum;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedStealerLeak
     */
    readed?: boolean;
    /**
     * 
     * @type {TwoFaStatusEnum}
     * @memberof PatchedStealerLeak
     */
    twoFaStatus?: TwoFaStatusEnum;
    /**
     * 
     * @type {StealerLeakSeverityEnum}
     * @memberof PatchedStealerLeak
     */
    severity?: StealerLeakSeverityEnum;
    /**
     * 
     * @type {string}
     * @memberof PatchedStealerLeak
     */
    impact?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedStealerLeak
     */
    recommendation?: string;
    /**
     * 
     * @type {number}
     * @memberof PatchedStealerLeak
     */
    assignedTo?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedStealerLeak
     */
    readonly assignedToDetails?: string;
    /**
     * 
     * @type {Status111Enum}
     * @memberof PatchedStealerLeak
     */
    status?: Status111Enum;
}



/**
 * Check if a given object implements the PatchedStealerLeak interface.
 */
export function instanceOfPatchedStealerLeak(value: object): value is PatchedStealerLeak {
    return true;
}

export function PatchedStealerLeakFromJSON(json: any): PatchedStealerLeak {
    return PatchedStealerLeakFromJSONTyped(json, false);
}

export function PatchedStealerLeakFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchedStealerLeak {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'identifier': json['identifier'] == null ? undefined : json['identifier'],
        'password': json['password'] == null ? undefined : json['password'],
        'url': json['url'] == null ? undefined : json['url'],
        'owner': json['owner'] == null ? undefined : OwnerEnumFromJSON(json['owner']),
        'createdAt': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'updatedAt': json['updated_at'] == null ? undefined : (new Date(json['updated_at'])),
        'device': json['device'] == null ? undefined : json['device'],
        'deviceInfo': json['device_info'] == null ? undefined : json['device_info'],
        'domain': json['domain'] == null ? undefined : json['domain'],
        'domainName': json['domain_name'] == null ? undefined : json['domain_name'],
        'service': json['service'] == null ? undefined : json['service'],
        'serviceName': json['service_name'] == null ? undefined : json['service_name'],
        'isMobile': json['is_mobile'] == null ? undefined : json['is_mobile'],
        'validity': json['validity'] == null ? undefined : ValidityEnumFromJSON(json['validity']),
        'readed': json['readed'] == null ? undefined : json['readed'],
        'twoFaStatus': json['two_fa_status'] == null ? undefined : TwoFaStatusEnumFromJSON(json['two_fa_status']),
        'severity': json['severity'] == null ? undefined : StealerLeakSeverityEnumFromJSON(json['severity']),
        'impact': json['impact'] == null ? undefined : json['impact'],
        'recommendation': json['recommendation'] == null ? undefined : json['recommendation'],
        'assignedTo': json['assigned_to'] == null ? undefined : json['assigned_to'],
        'assignedToDetails': json['assigned_to_details'] == null ? undefined : json['assigned_to_details'],
        'status': json['status'] == null ? undefined : Status111EnumFromJSON(json['status']),
    };
}

  export function PatchedStealerLeakToJSON(json: any): PatchedStealerLeak {
      return PatchedStealerLeakToJSONTyped(json, false);
  }

  export function PatchedStealerLeakToJSONTyped(value?: Omit<PatchedStealerLeak, 'id'|'created_at'|'updated_at'|'device_info'|'domain_name'|'service_name'|'assigned_to_details'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'identifier': value['identifier'],
        'password': value['password'],
        'url': value['url'],
        'owner': OwnerEnumToJSON(value['owner']),
        'device': value['device'],
        'domain': value['domain'],
        'service': value['service'],
        'is_mobile': value['isMobile'],
        'validity': ValidityEnumToJSON(value['validity']),
        'readed': value['readed'],
        'two_fa_status': TwoFaStatusEnumToJSON(value['twoFaStatus']),
        'severity': StealerLeakSeverityEnumToJSON(value['severity']),
        'impact': value['impact'],
        'recommendation': value['recommendation'],
        'assigned_to': value['assignedTo'],
        'status': Status111EnumToJSON(value['status']),
    };
}

